import FilterDropdown from './FilterDropdown.js';

export default function AppointmentHeader({ onFilterChange }) {
    return (
        <div className="flex justify-between items-center mb-6 p-4 lg:p-8">
            <h1 className="text-[18px] font-[500] text-[#131416]">Appointment Requests</h1>
            <FilterDropdown onFilterChange={onFilterChange} />
        </div>
    );
}
